import React from 'react';
import PropTypes from 'prop-types';

import Publication from './Publications/Publication';

const Publications = ({ data = [] }) => (
  <div className="publications">
    <div className="link-to" id="publications" />
    <div className="title">
      <h3>Selected Publications</h3>
      <p>A full list is available on request.</p>
    </div>
    {data.map((publication) => (
      <Publication
        data={publication}
        key={publication.doi || publication.title}
      />
    ))}
  </div>
);

Publications.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    authors: PropTypes.string,
    journal: PropTypes.string,
    doi: PropTypes.string,
    link: PropTypes.string,
  })),
};

export default Publications;
